import React, {ReactNode} from 'react';
import {t} from '@lingui/core/macro';

import cn from 'classnames';

import {isTranslate} from '../../../../../shared/lib/lang';

import styles from './AskEmail.module.scss';

interface AskEmailProps {
    children: ReactNode;
}

const AskEmail: React.FC<AskEmailProps> = ({children}) => {
    return (
        <div className={cn(styles.container, isTranslate() && styles.colorLinkEn)}>
            <h3 className={styles.title}>{t`Что делать`}?</h3>
            <div className={styles.text}>{children}</div>
        </div>
    );
};

export default AskEmail;